<template>
  <v-form
    ref="form"
    v-model="valid"
    :disabled="$store.getters.isLoading"
    class="px-lg-5 pt-5"
  >
    <v-row no-gutters justify="space-between" class="test_blue">
      <v-col cols="12" class="test_purple px-2">
        <v-item-group
          v-model="formAddress.addressTitle"
          mandatory
          active-class="text-white"
        >
          <v-container>
            <v-row justify="center">
              <v-col
                v-for="(item, index) in types"
                :key="index"
                cols="6"
                sm="4"
                class="test_yellow"
              >
                <v-item v-slot="{ active, toggle }" :value="item.name">
                  <v-card
                    :color="active ? 'primary' : ''"
                    class="d-flex align-center"
                    height="80"
                    width="100%"
                    @click="toggle"
                  >
                    <v-scroll-y-transition>
                      <v-container fluid pa-0 ma-0 fill-height class="test_red">
                        <v-row
                          no-gutters
                          justify="center"
                          class="fill-height test_blue"
                          align="center"
                        >
                          <div class="test_green text-center">
                            <v-icon
                              large
                              :color="active ? 'white' : 'black'"
                              v-text="item.icon"
                            />
                            <br />
                            <span class="type-title" v-text="item.name" />
                          </div>
                        </v-row>
                      </v-container>
                    </v-scroll-y-transition>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-col>
      <v-col cols="12" class="test_purple px-2">
        <PlaceAutocompleteInput
          v-model="components"
          :label="$t('inputs.dropoff_address')"
        />
      </v-col>
      <v-col cols="12" md="6" class="test_purple px-2">
        <v-text-field
          v-model="formAddress.streetName"
          :label="$t('inputs.street')"
          clearable
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" class="test_purple px-2">
        <v-text-field
          v-model="formAddress.buildingNo"
          :label="$t('inputs.building_number')"
          clearable
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" class="test_purple px-2">
        <v-text-field
          v-model="formAddress.postCode"
          :label="$t('inputs.postal_code')"
          clearable
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" class="test_purple px-2">
        <v-text-field
          v-model="formAddress.city"
          :label="$t('inputs.city')"
          clearable
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" md="6" class="test_purple px-2">
        <v-text-field
          v-model="formAddress.floor"
          :label="$t('inputs.floor')"
          clearable
        />
      </v-col>

      <v-col cols="12" md="6" class="test_purple px-2">
        <v-textarea
          v-model="formAddress.additionalInstructions"
          rows="1"
          auto-grow
          clearable
          :label="$t('inputs.additional_instructions')"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "FormAddressComponent",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    components: null,
    valid: false,
    types: [
      { name: "Home", icon: "mdi-home" },
      { name: "Office", icon: "mdi-city" },
    ],
    formAddress: new Form({
      addressTitle: null,
      prettyAddress: null,
      streetName: null,
      buildingNo: null,
      postCode: null,
      city: null,
      floor: "",
      description: "",
      isActive: 1,
    }),
  }),
  watch: {
    valid: function () {
      if (this.valid) {
        this.$emit("input", this.formAddress);
      } else {
        this.$emit("input", false);
      }
    },
    components: function () {
      const self = this;
      self.showAddressError = false;
      if (self.components) {
        self.formAddress.keys().forEach((key) => {
          switch (true) {
            case key == "streetName":
              self.formAddress.streetName = self.components.street;
              break;
            case key == "buildingNo":
              self.formAddress.buildingNo = self.components.buildingNumber;
              break;
            case key == "postCode":
              self.formAddress.postCode = self.components.postalCode;
              break;
            case key == "floor":
              this.formAddress.floor =
                self.components.floor == null ? "" : self.components.floor;
              break;
            case key == "description":
              break;
            case key == "addressTitle":
              break;
            case key == "isActive":
              break;
            default:
              self.formAddress[key] = self.components[key];
              break;
          }
        });
      } else {
        this.formAddress.keys().forEach((key) => {
          this.formAddress[key] = null;
          this.showAddressError = false;
        });
      }
    },
  },
  mounted() {
    if (this.id > 0) {
      this.showEdit(this.id);
    }
  },
  methods: {
    showEdit: async function (id) {
      const self = this;
      self.$store.dispatch("loading/start");
      self.dialog = true;
      self.idAddressBook = id;
      const { data } = await self.formAddress.get(
        "/users/profiles/address/book/" + id
      );
      self.formAddress.keys().forEach((key) => {
        self.formAddress[key] = data.data[key];
      });
      self.$store.dispatch("loading/done");
    },
  },
};
</script>
<style lang="scss" scoped>
.text-white {
  color: #fff !important;
}
</style>
